import { render, staticRenderFns } from "./ExamsNotIdentified.partial.vue?vue&type=template&id=589ecc7a&scoped=true"
import script from "./ExamsNotIdentified.partial.vue?vue&type=script&lang=js"
export * from "./ExamsNotIdentified.partial.vue?vue&type=script&lang=js"
import style0 from "./ExamsNotIdentified.partial.vue?vue&type=style&index=0&id=589ecc7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589ecc7a",
  null
  
)

export default component.exports